import {
    NEWLEAVEREQUESTCREATE,
    NEWLEAVEREQUESTCREATE_FAIL,
    NEWLEAVEREQUESTCREATE_SUCCESS,
    GET_NEWLEAVESHAREREQUEST_REQUEST_DETAILS,
    GET_NEWLEAVESHAREREQUEST_REQUEST_DETAILS_SUCCESS,
    GET_NEWLEAVESHAREREQUEST_REQUEST_DETAILS_FAIL,
    UPDATE_NEWLEAVESHAREREQUEST_REQUEST,
    UPDATE_NEWLEAVESHAREREQUEST_REQUEST_SUCCESS,
    UPDATE_NEWLEAVESHAREREQUEST_REQUEST_FAIL,
    DELETE_NEWLEAVESHAREREQUEST_REQUEST,
    DELETE_NEWLEAVESHAREREQUEST_REQUEST_SUCCESS,
    DELETE_NEWLEAVESHAREREQUEST_REQUEST_FAIL,
    Get_Audit_Trail_Success,
    Get_Audit_Trail,
    Get_Audit_Trail_Fail,
    Get_Audit_Trail_History,
    Get_Audit_Trail_Success_History,
    Get_Audit_Trail_Fail_History
} from "./actionTypes";

const initialState = {
    NEWLEAVESHAREREQUESTRequestList: [],
    NEWLEAVESHAREREQUESTRequestDetails: [],
    createLeaveRequest: {},
    loading: false,
    detailsLoading: false,
    loadingRequest: false,
    deleteResult: {},
    error: {
        message: "",
    },
    updateRequest:false,
    createLeave:false,
    auditTrailData:{},
    auditTrailHistoryData:[]
};

const NEWLEAVESHAREREQUESTRequestReducer = (state = initialState, action) => {
    if (!action) return state;

    switch (action.type) {
        case NEWLEAVEREQUESTCREATE:
            return { ...state, createLeaveRequest: {}, loadingRequest: true, createLeave:true};
        case NEWLEAVEREQUESTCREATE_SUCCESS:
            return { ...state, createLeaveRequest: action.payload, loadingRequest: false, createLeave:false };
        case NEWLEAVEREQUESTCREATE_FAIL:
            return {
                ...state,
                error: { message: "Error" },
                createLeaveRequest: {},
                loadingRequest: false,
                createLeave: false
            };

        case GET_NEWLEAVESHAREREQUEST_REQUEST_DETAILS:
            return { ...state, detailsLoading: true, NEWLEAVESHAREREQUESTRequestDetails: {} };
        case GET_NEWLEAVESHAREREQUEST_REQUEST_DETAILS_SUCCESS:
            return { ...state, NEWLEAVESHAREREQUESTRequestDetails: action.payload, detailsLoading: false };
        case GET_NEWLEAVESHAREREQUEST_REQUEST_DETAILS_FAIL:
            return {
                ...state,
                error: { message: "Error" },
                detailsLoading: false,
            };

        case UPDATE_NEWLEAVESHAREREQUEST_REQUEST:
            return { ...state, createLeaveRequest: {}, loading: true, updateRequest:true };
        case UPDATE_NEWLEAVESHAREREQUEST_REQUEST_SUCCESS:
            return { ...state, createLeaveRequest: action.payload, loading: false, updateRequest:false };
        case UPDATE_NEWLEAVESHAREREQUEST_REQUEST_FAIL:
            return {
                ...state,
                error: { message: "Error" },
                loading: false,
                updateRequest: false
            };

        case DELETE_NEWLEAVESHAREREQUEST_REQUEST:
            return { ...state, deleteResult: {}, loading: true };
        case DELETE_NEWLEAVESHAREREQUEST_REQUEST_SUCCESS:
            return { ...state, deleteResult: action.payload, loading: false };
        case DELETE_NEWLEAVESHAREREQUEST_REQUEST_FAIL:
            return {
                ...state,
                error: { message: "Error" },
                loading: false,
                deleteResult: {},
            };
        case Get_Audit_Trail:
            return {...state,auditTrailData:{}};
        case Get_Audit_Trail_Success:
            return {...state,auditTrailData:action.payload};
        case Get_Audit_Trail_Fail:
            return {...state,
                error: { message: "Error" },
                auditTrailData: {},
            };
        case Get_Audit_Trail_History:
            return { ...state, auditTrailHistoryData:[] };
        case Get_Audit_Trail_Success_History:
            return { ...state,auditTrailHistoryData:action.payload };
        case Get_Audit_Trail_Fail_History:
            return { ...state,
                auditTrailHistoryData:[],
                error: { message: "Error" },
             };
        default:
            return state;
    }
};

export default NEWLEAVESHAREREQUESTRequestReducer;
